import { ConsentLevel, useConsentState } from '@news-mono/web-common'
import React from 'react'
import { AmpAnalytics } from '../analytics'

interface SmartOctoProperties {
    id: string
    postid: string
    title: string
    pubdate: string
    authors: string
    sections: string
    tags: string
}

interface AmpGtmProps {
    gtmId: string
    smartOctoProperties?: SmartOctoProperties
}

export const AmpGtm: React.FC<AmpGtmProps> = ({
    gtmId,
    smartOctoProperties,
}) => {
    const consent = useConsentState()

    const gtmConfig = {
        vars: {
            consent: consent.consentLevel ?? ConsentLevel.Essential,
            ...smartOctoProperties,
        },
    }

    return (
        <AmpAnalytics
            config={`https://www.googletagmanager.com/amp.json?id=${gtmId}&gtm.url=SOURCE_URL`}
            data-credentials="include"
            dangerouslySetInnerHTML={{
                __html: `
                <script type="application/json">
                    ${JSON.stringify(gtmConfig)}
                </script>`,
            }}
        ></AmpAnalytics>
    )
}
